import React from "react";
import Avatar from "../../theme/untitled/Avatar/Avatar";
import Icon from "../../theme/untitled/icons/Icon";
import Badge from "../../theme/untitled/Badge/Badge";
import RowActionsMenu from "./RowActionsMenu";
import { formatRelativeTime } from "./relativeTime";
import { ROLE_LABELS, ROLE_OWNER } from "./constants";
import styles from "./MembersPage.module.scss";

const MembersMobileList = ({ rows, ownerCount, onChangeRole, onOpenRemove, onResendInvite, onRevokeInvite }) => (
  <div>
    {rows.map((row) => {
      const isSoleOwner = row.role === ROLE_OWNER && ownerCount === 1;
      return (
        <div className={styles.mobileRow} key={row.uuid}>
          {row.status === "pending" ? (
            <Avatar className={styles.avatar} icon={<Icon name="AtSign" size={18} />} />
          ) : (
            <Avatar className={styles.avatar} initials={row.initials} />
          )}
          <span>
            <span className={styles.mobileRowLine1}>
              <b>{row.name}</b>
              {row.status === "pending" && (
                <Badge color="warning" size="sm" dot>
                  Pending
                </Badge>
              )}
              {row.isCurrentUser && <span className={styles.youPill}>You</span>}
            </span>
            <span className={styles.mobileRowLine2}>
              {row.status === "pending"
                ? row.createdAt
                  ? `Invited ${formatRelativeTime(row.createdAt)}`
                  : "Invited"
                : `${row.email} · ${ROLE_LABELS[row.role]}`}
            </span>
          </span>
          <RowActionsMenu
            row={row}
            isSoleOwner={isSoleOwner}
            onChangeRole={onChangeRole}
            onOpenRemove={onOpenRemove}
            onResendInvite={onResendInvite}
            onRevokeInvite={onRevokeInvite}
          />
        </div>
      );
    })}
  </div>
);

export default MembersMobileList;
